import CustomSelect from 'components/CustomSelect'
import { GET, httpOk, POST } from 'helpers/api'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';

const initData = {
    production_order_id: '',
    quantity: '',
    unit_id: '',
    comment: '',
};

function AcceptanceProduction({ modal, setModal }) {
    const { t } = useTranslation();

    const [sendData, setSendData] = useState({ ...initData })

    const [products, setProducts] = useState([])
    const [units, setUnits] = useState([])

    async function create() {
        var sendDataCopy = { ...sendData }
        const response = await POST('/inventory/receive-fg/', sendDataCopy)
        if (httpOk(response)) {
            setModal(false);
            setSendData({ ...initData });
        }
    }

    function handleChange(e) {
        var sendDataCopy = { ...sendData };
        sendDataCopy[e.target.name] = e.target.value;
        setSendData(sendDataCopy);
    }


    useEffect(() => {
        async function getRawMaterials() {
            const response = await GET('/production/orders/')
            if (httpOk(response)) {
                setProducts(response.data)
            }
        }

        async function getUnits() {
            const response = await GET('/catalogs/units/')
            if (httpOk(response)) {
                setUnits(response.data)
            }
        }

        getRawMaterials()
        getUnits()
    }, []);

    return (
        <>
            <Modal show={modal} centered onHide={() => setModal(false)}>
                <i className="uil-times" onClick={() => setModal(false)}></i>
                <div className="modal-title mb-12">
                    {t('receipt_from_production')}
                </div>
                <div className="modal-subtitle mb-32">
                    {t('register_fg_receipt_desc')}
                </div>

                <div className="d-flex flex-column gap-16 mb-32">
                    <div className="form-group">
                        <label>{t('production_order')}</label>
                        <CustomSelect
                            options={products}
                            value={products?.find(option => option.id === sendData?.production_order_id) || ''}
                            getOptionLabel={(option) => `${option.order_number} - ${option.product_name}`}
                            onChange={(option) => setSendData({ ...sendData, production_order_id: option.id, unit_id: option.unit_id })}
                            placeholder={t('select_order')}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('sku')}</label>
                        <input type="text" placeholder={t('status')} name="planned_quantity"
                            value={sendData.planned_quantity} onChange={(e) => handleChange(e)} disabled />
                    </div>

                    <div className="grid2 gap-16">
                        <div className="form-group">
                            <label>{t('actual_volume')}</label>
                            <input type="text" placeholder={t('actual_volume')} name="quantity"
                                value={sendData.quantity} onChange={(e) => handleChange(e)} />
                        </div>
                        <div className="form-group">
                            <label>{t('unit_of_measurement')}</label>
                            <CustomSelect
                                options={units}
                                value={units?.find(option => option.id === sendData?.unit_id) || ''}
                                onChange={(option) => setSendData({ ...sendData, unit_id: option.id })}
                                placeholder={t('unit_short')}
                            />
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <label>{t('comment')}</label>
                        <input type="text" placeholder={t('additional_info')} name="comment"
                            value={sendData.comment} onChange={(e) => handleChange(e)} />
                    </div>
                </div>

                <div className="modal-footer">
                    <button className="white" onClick={() => setModal(false)}>
                        {t('cancel')}
                    </button>
                    <button className="dark" onClick={() => create()}>
                        {t('create_order')}
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default AcceptanceProduction